import React from "react";
import { useApp } from "context";
import {
  DataGrid as MUIDataGrid,
  GridToolbar,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

type Props = {
  sx?: any;
  columns: any;
  rows: Array<any>;
  isLoading: boolean;
  pageSize?: number;
  quickSearch?: boolean;
  getRowId: (row: any) => any;
  onSelect?: (value: any) => void;
};

export const DataGrid = (props: Props) => {
  const { theme } = useApp();

  const quickSearch = () => {
    return (
      <GridToolbarQuickFilter
        spellCheck={false}
        sx={{
          color: theme.palette.font.color,
          backgroundColor: theme.palette.background.color,
          paddingBottom: 0,
          marginLeft: "0.5rem",
          marginTop: "0.5rem",
          zoom: 1.5,
          "& input": { color: theme.palette.font.color },
        }}
      />
    );
  };

  return (
    <MUIDataGrid
      sx={{
        color: theme.palette.font.color,
        borderColor: theme.palette.font.color,
        "& .MuiToolbar-root": {
          color: theme.palette.font.color,
        },
        "& .MuiSvgIcon-root": {
          color: theme.palette.font.color,
        },
        ...props.sx,
      }}
      initialState={{
        pagination: {
          paginationModel: { pageSize: props.pageSize || 100, page: 0 },
        },
      }}
      slots={{ toolbar: props.quickSearch && quickSearch }}
      // pageSize={5}
      autoHeight={!props.sx?.height}
      checkboxSelection={!!props.onSelect}
      rows={props.rows}
      disableColumnMenu
      // rowsPerPageOptions={[5]}
      key={props.getRowId}
      columns={props.columns}
      disableColumnSelector
      getRowId={props.getRowId}
      isLoading={props.isLoading}
      disableRowSelectionOnClick
      onRowSelectionModelChange={props.onSelect}
    />
  );
};
